import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import FancyTitle from '../fancy-title';


export default function ChecklistBox({ blok }) {
  const {
    items,
    title,
    buttonLink,
    buttonText,
    titleColumnWidth,
    itemsColumnWidth,
  } = blok;

  // Add defensive check for nested content
  const listItems = items?.content?.[0]?.content || [];

  // Helper function to safely get text content
  const getTextContent = (listItem) => {
    const text = listItem?.content?.[0]?.content?.[0]?.text;
    if (!text) return { title: '', subtitle: '' };

    const parts = text.split('//');
    return {
      title: parts[0] || '',
      subtitle: parts[1] || ''
    };
  };

  return (
    <div className="bg-black py-[70px] px-8 lg:px-20 green-background-double">
      <div className="flex flex-col gap-y-10 lg:gap-y-0 lg:gap-x-20 lg:flex-row items-center  z-1 relative">
        <div {...(titleColumnWidth && { customStyleOverrides: { flex: `0 0 ${titleColumnWidth}%` } })}>
          <FancyTitle
            text={title}
            textAlign="text-left"
            className="mx-auto text-white"
            marginBottom="mb-0"
            tag="h2"
          />

          <Link
            to={buttonLink.cached_url || buttonLink.url || '#'}
            title={buttonLink?.link_title || undefined}
            className="button-general mt-8 mb-0 md:mb-8 lg:mb-0 w-max !hidden md:!block"
          >
            {buttonText}
          </Link>
        </div>
        <div className="flex-column flex mt-12 lg:mt-0" {...(itemsColumnWidth && { style: { flex: `0 0 ${itemsColumnWidth}%` } })}>
          {items && (
            <ul className="flex flex-col gap-y-16">
              { listItems.map((listItem) => (
                <li className="text-white flex gap-x-8 items-center">
                  <StaticImage
                    className="aspect-square object-cover min-w-[30px]"
                    layout="fixed"
                    formats={['auto', 'webp', 'avif']}
                    src="../../images/checkbox.svg"
                    width={30}
                    height={30}
                    alt="Checkbox Icon"
                  />
                  <div>
                    <p className="text-2xl font-normal">
                      {listItem?.content?.[0]?.content?.[0]?.text?.split('//')[0] || ''}
                    </p>
                    <span className="text-sm mt-[20px] font-light block">
                      {listItem?.content?.[0]?.content?.[0]?.text?.split('//')[1] || ''}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="w-full flex z-1 relative justify-center md:hidden">
        <Link
          to={buttonLink.cached_url || buttonLink.url || '#'}
          title={buttonLink?.link_title || undefined}
          className="button-general mt-8 w-max block md:hidden"
        >
          {buttonText}
        </Link>
      </div>
    </div>
  );
}
